import { Vector2 } from "peet-math";
import { Control } from "./control";
import { cssDummyToStyle, getStylingDummy } from "./util";
import $ from "jquery"
import { ViewPort } from "./viewport";

// Scene or event location marker
export class EventLocationControl extends Control {
  public containerTag: JQuery<HTMLElement>;
  public position: Vector2;
  public style: any;
  public cssDummy: any;

  constructor(containerTag: JQuery<HTMLElement>, position: Vector2) {
    super();
    this.render = this.render.bind(this);
    this.containerTag = containerTag;
    this.position = position;
    this.cssDummy = getStylingDummy('eventLocationMarker');
    this.containerTag.append($(this.cssDummy));
    this.style = cssDummyToStyle(this.cssDummy);
  }

    //containerTag.append
    
  render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
    if (this.visible) {
      const posOnView = viewport.pointPToV(this.position);
      // If canvas available:
      if (canvasCtx != null) {
        const c = canvasCtx;
        const radius = viewport.scalarPToV(50);
        c.beginPath();
        c.arc(posOnView.x, posOnView.y, radius, 0, 2 * Math.PI, false);
        c.fillStyle = this.style.backgroundColor;
        c.fill();
        c.lineWidth = 3;
        c.strokeStyle = this.style.borderColor;
        return c.stroke();
      }
    }
  }
}